<!--
---
--- View: Display Errors for Admin only!
---
-->
<template>
    <v-container>
        <v-alert :value="error!=null" type="error">{{error}}</v-alert>
        <v-progress-linear v-if="isProcessing" :indeterminate="true"/>

        <div class="text-xs-center pt-2">
            <v-pagination v-model="page" :length="pages"></v-pagination>
        </div>

        <v-data-table
                must-sort
                hide-actions
                :headers="headers"
                :items="errorsArray"
                :search="search"
                :total-items="pagination.totalItems"
                :rows-per-page-items="pagination.rowsPerPageItems"
                :loading="loading"
                :pagination.sync="pagination"
                class="elevation-1">
            <template v-slot:items="props">
                <td>{{ props.item.date_dt }}</td>
                <td>{{ props.item.user_t }}</td>
                <td>{{ props.item.company_t }}</td>
                <td>{{ props.item.error_t }}</td>
            </template>
        </v-data-table>



    </v-container>

</template>

<script>
    import WebService from "@/services/WebService"

    export default {
        data() {
            return {
                search: '',
                pagination: {
                    rowsPerPage: 9,
                    sortBy: 'date_dt',
                    descending: true
                },
                page: 1,
                selected: [],
                headers: [
                    {text: 'Date', value: 'date_dt'},
                    {text: 'User', value: 'user_t'},
                    {text: 'Company', value: 'company_t'},
                    {text: 'Message', value: 'error_t'}
                ],
                errorsArray: [],
                loading: false,
            }
        },
        computed: {
            pages() {
                if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) return 0
                return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
            },

            error() {
                return this.$store.state.error
            },

            isProcessing() {
                return this.$store.state.isProcessing
            },

            sortField() {
                return this.pagination.sortBy + (this.pagination.descending ? " desc" : " asc")
            }
        },

        methods: {
            loadPage() {
                this.$store.dispatch("setError", null)
                var sortField = this.sortField
                var count = this.pagination.rowsPerPage
                var start = (this.page - 1) * this.pagination.rowsPerPage
                this.loading = true

                new WebService(this).getErrors(sortField, start, count).then(response => {
                    if (response.status == 200) {
                        this.pagination.totalItems = response.data.response.numFound
                        this.errorsArray = response.data.response.docs
                        this.errorsArray.forEach(r => {
                            if (r.companyAccountNumber )
                                r.companyAccountNumber = r.companyAccountNumber.join(" ")
                        })
                    } else {
                        this.$store.dispatch("setError", response.data.message)
                    }
                    this.loading = false
                }).catch(error => {
                    this.$store.dispatch("setError", error)
                })
            }
        },

        watch: {
            page: {
                immediate: true,

                // eslint-disable-next-line
                handler(newVal, oldVal) {
                    if (this.pagination.sortBy) {
                        this.loadPage()
                    }
                }
            },

            sortField: {
                // eslint-disable-next-line
                handler(newVal, oldVal) {
                    this.loadPage()
                }
            }
        }
    }

</script>

<style scoped>

</style>